import {combineReducers} from 'redux';
import {UserActions, userPersistConfig, users} from './user';
import {persistReducer} from 'redux-persist';
import {RoleActions, roles} from './role';
import {ItemActions, items} from './inventory/item';
import {OrderItemActions, orderItems} from './inventory/joining/orderItem';
import {OrderActions, orders} from './inventory/order';
import {itemCategories, ItemCategoryActions} from './inventory/joining/itemCategory';
import {categories, CategoryActions} from './inventory/category';
import {transfers} from "./inventory/transfer";
import {auditlogs} from "./auditlog";
import {programs, ProgramActions} from "./inventory/program";
import {houses, HouseActions} from "./inventory/house";

export const entities = combineReducers({
  users: persistReducer(userPersistConfig, users) as unknown as typeof users,
  roles: roles,
  orders: orders,
  items: items,
  transfers: transfers,
  auditlogs: auditlogs,
  categories: categories,
  orderItems: orderItems,
  itemCategories: itemCategories,
  programs: programs,
  houses: houses
});

export type Entities  = ReturnType<typeof entities>;

export type EntitiesActions = UserActions | RoleActions | OrderActions | ItemActions | CategoryActions | OrderItemActions | ItemCategoryActions | ProgramActions | HouseActions;
